import { ApiClient } from './client.js'
import { RELEASES } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (releaseId) {
    return client.get(`${RELEASES}${releaseId}/`)
  },

  list () {
    return client.get(`${RELEASES}`)
  }
}
